import { useQuery } from "@tanstack/react-query";
import { getDeviceSettings } from "../api/fetchers/deviceSettingsFetcher";

const useDeviceSettings = ({ page = 1, limit = 10, searchValue = null, enabled = true }) => {
    return useQuery({
        queryKey: ["deviceSettings", page],
        queryFn: () => getDeviceSettings(page, limit, searchValue),
        enabled: enabled,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};

export default useDeviceSettings;
